/* Native touch scrolling, with mouse dragging for desktop and theme-editor previews. */
(() => {
  if (window.vivimiaDragScrollReady) return;
  window.vivimiaDragScrollReady = true;
  let drag = null;
  let lastDrag = null;
  document.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const rail = event.target.closest('[data-vivimia-drag-scroll]');
    if (!rail || rail.scrollWidth <= rail.clientWidth + 1) return;
    drag = { rail, id:event.pointerId, x:event.clientX, y:event.clientY, left:rail.scrollLeft, moved:false };
  });
  document.addEventListener('pointermove', event => {
    if (!drag || drag.id !== event.pointerId) return;
    const dx = event.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(event.clientY - drag.y)) return;
      drag.moved = true;
      drag.rail.setPointerCapture(event.pointerId);
    }
    event.preventDefault();
    drag.rail.scrollLeft = drag.left - dx;
  }, { passive:false });
  const finish = event => {
    if (!drag || drag.id !== event.pointerId) return;
    if (drag.moved) lastDrag = { rail:drag.rail, time:performance.now() };
    if (drag.rail.hasPointerCapture(event.pointerId)) drag.rail.releasePointerCapture(event.pointerId);
    drag = null;
  };
  document.addEventListener('pointerup', finish);
  document.addEventListener('pointercancel', finish);
  document.addEventListener('click', event => {
    if (lastDrag && performance.now() - lastDrag.time < 400 && lastDrag.rail.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      lastDrag = null;
    }
  }, true);
  document.addEventListener('dragstart', event => {
    if (event.target.closest('[data-vivimia-drag-scroll]')) event.preventDefault();
  });
})();
